import { ActionTypes } from '../actions';

const ProfileReducer = (state = true, action) => {
  switch (action.type) {
    case ActionTypes.PROFILEBUTTON:
      return action.payload;
    default:
      return state;
  }
};

export default ProfileReducer;
